var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.20684 1.5L8.57729 9.77336L2.16669 16.5H3.60957L9.22217 10.6106L13.7568 16.5H18.6667L11.9377 7.76136L17.9047 1.5H16.4618L11.2931 6.92386L7.11669 1.5H2.20684ZM4.32866 2.53222H6.58422L16.5446 15.4678H14.289L4.32866 2.53222Z","fill":"currentColor"}));
}

SVGIcon.defaultProps = {"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
